// SPDX-License-Identifier: AGPL-3.0-or-later

import {buildCustomEmojiURL} from '@app/features/expressions/utils/CustomEmojiImageUrl';
import styles from '@app/features/guild/components/RoleName.module.css';
import {parseRoleNameParts} from '@app/features/guild/utils/RoleNameText';
import {clsx} from 'clsx';
import type React from 'react';

interface RoleNameProps {
	name: string;
	className?: string;
}

export const RoleName: React.FC<RoleNameProps> = ({name, className}) => {
	const parts = parseRoleNameParts(name);
	return (
		<span className={clsx(styles.root, className)} data-flx="guild.role-name.root">
			{parts.map((part, index) => {
				if (part.kind === 'text') {
					if (part.value.length === 0) {
						return null;
					}
					return (
						<span key={`text-${index}`} data-flx="guild.role-name.text">
							{part.value}
						</span>
					);
				}
				return (
					<img
						key={`emoji-${part.id}-${index}`}
						className={styles.emoji}
						src={buildCustomEmojiURL({id: part.id, animated: part.animated})}
						alt={`:${part.name}:`}
						draggable={false}
						data-flx="guild.role-name.emoji"
					/>
				);
			})}
		</span>
	);
};
